import { atQuery } from '../components/mediaQueries';

document.addEventListener('DOMContentLoaded', function () {
  [].forEach.call(document.querySelectorAll('.carousel-banner'), function (el) {
    window.dAgency.initCarouselBanner(el);
  });
});

if (!window.dAgency) window.dAgency = {};
window.dAgency.initCarouselBanner = (context) => {
  let desktopSpaceBetween = 15;
  if (
    !context ||
    context.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide')
      .length < 1
  )
    return;

  if (context.dataset.carouselLayout === 'fullwidth') {
    desktopSpaceBetween = 1;
  }

  const carouselSwiper = new Swiper(context, {
    autoplay: {
      delay: 3000,
      pauseOnMouseEnter: true,
    },
    speed: 500,
    effect: 'coverflow',
    coverflowEffect: {
      depth: 0,
      rotate: 0,
      scale: 0.8,
      slideShadows: false,
      stretch: 8,
    },
    slidesPerView: 1,
    spaceBetween: 0,
    breakpoints: {
      769: {
        effect: null,
        slidesPerView: 4.1,
        spaceBetween: desktopSpaceBetween,
      },
    },
    scrollbar: {
      el: context.querySelector('.carousel-banner__scrollbar'),
      draggable: true,
      dragSize: 100,
    },
  });
  carouselSwiper.on('scrollbarDragStart', (swiper, event) => {
    swiper?.scrollbar?.dragEl?.classList.add('active');
  });
  carouselSwiper.on('scrollbarDragEnd', (swiper, event) => {
    swiper?.scrollbar?.dragEl?.classList.remove('active');
  });

  const firstSlide = context.querySelector(
    ':scope > .swiper-wrapper > .swiper-slide',
  );
  const scaledOffset =
    (firstSlide.clientWidth * 1.12 - firstSlide.clientWidth) / 2;
  const allSlides = context.querySelectorAll(
    ':scope > .swiper-wrapper > .swiper-slide',
  );
  allSlides.forEach((swiperSlide, i) => {
    const prevSlides = [];
    const nextSlides = [];
    allSlides.forEach((slide, j) => {
      if (i > j) {
        prevSlides.push(slide);
      } else if (i < j) {
        nextSlides.push(slide);
      }
    });

    swiperSlide.addEventListener('mouseenter', () => {
      if (window.innerWidth > 768) {
        swiperSlide.style.zIndex = '1';
        swiperSlide.style.transform = 'scale(1.12)';
        prevSlides.forEach((prevSlide) => {
          prevSlide.style.transform = `translateX(-${scaledOffset}px)`;
        });
        nextSlides.forEach((nextSlide) => {
          nextSlide.style.transform = `translateX(${scaledOffset}px)`;
        });
      }
    });

    swiperSlide.addEventListener('mouseleave', () => {
      if (window.innerWidth > 768) {
        swiperSlide.style.zIndex = '';
        allSlides.forEach((slide) => {
          slide.style.transform = '';
        });
      }
    });
  });

  atQuery('max', 'md', () => {
    allSlides.forEach((slide) => {
      slide.style.transform = '';
    });
  });
};
